import { FetchError } from 'ofetch';

// Bare `FetchError` means `FetchError<any>`, which would hand callers an unchecked `data`.
export default (error: unknown): error is FetchError<unknown> => error instanceof FetchError;
